import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SIDEKICK_TRANSLATION_NAMESPACE } from '../../translations';
import useStyles from './SidekickDisclaimerBanner.styles';

export type SidekickDisclaimerBannerProps = {
  /** Whether the M1 visual treatment is active. */
  isM1Enabled?: boolean;
};

/**
 * Persistent AI disclaimer banner shown at the bottom of the Sidekick
 * chat, directly above the input dock. Rendered unconditionally by
 * `ChatInterface`, so it persists for the whole conversation (the
 * ChatGPT / Claude pattern). While the first-time consent gate is
 * showing it stays part of the chat surface behind the gate's
 * translucent scrim — dimmed rather than hidden — matching the Figma
 * mock. Purely presentational; renders the localized `disclaimer.banner`
 * copy.
 */
function SidekickDisclaimerBanner({
  isM1Enabled = false,
}: SidekickDisclaimerBannerProps) {
  const { classes } = useStyles({ isM1Enabled });
  const { t } = useTranslation(SIDEKICK_TRANSLATION_NAMESPACE);

  return (
    <Box className={classes.banner} data-testid="ai-sidekick-disclaimer-banner">
      <Typography variant="caption_regular" className={classes.text}>
        {t('disclaimer.banner')}
      </Typography>
    </Box>
  );
}

export default SidekickDisclaimerBanner;
